import React, { createContext, useEffect, useState } from "react";
import { getReferentielDataFromServer } from "./AxiosReferencielInterceptor";
import config from "../../../config";

export const AuthContext = createContext();

const TSAuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || {});
  const [openLoginDialog, setOpenLoginDialog] = useState(false);

  // Pending MFA state — memory only, never localStorage
  const [mfaPending, setMfaPending] = useState(null);

  // MFA advice dialog — persisted here so it survives LoginDialog unmount
  //const [showMfaAdvice, setShowMfaAdvice] = useState(false);

  /*
  // ── Check MFA status and show advice if not enabled ────────────────────────
  const checkAndAdviseMfa = async (variant = "login") => {
    try {
      const res = await fetch(`${config.baseURL}api/user/mfa/status`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.ok) {
        const data = await res.json();
        if (!data.mfaEnabled) {
          setMfaAdviceVariant(variant);
          setShowMfaAdvice(true);
        }
      }
    } catch {
      // Silent fail — not critical
    }
  };
  */


const verifyOtp = async ({ email, password, otp, onSuccess, onFail }) => {
  await getReferentielDataFromServer(false, "api/user/get-token", {
    email, password, otp, source: "basic",
  })
    .then((response) => {
      if (response?.error || response?.requireOTP === true || response?.requireOTP === "true") {
        onFail?.("Code incorrect");
        return;
      }
      setToken(response);
      localStorage.setItem("token", response);
      localStorage.setItem("source", "basic");
      localStorage.setItem("provider_token", "");
      setMfaPending(null);
      onSuccess?.();
    })
    .catch(() => onFail?.("Erreur de connexion au serveur"));
};


const sendOtpMail = async ({ email,password, onSuccess, onFail }) => {
  try {
    const response = await fetch(`${config.baseURL}api/user/sendOtpMail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email , password}),
    });
    if (response.ok) {
      onSuccess?.();
    } else {
      const err = await response.json().catch(() => ({}));
      onFail?.(err?.message || "Échec de l'envoi du code par email");
    }
  } catch {
    onFail?.("Erreur de connexion au serveur");
  }
};
  // ── Login ──────────────────────────────────────────────────────────────────
const login = async (newToken) => {
  await getReferentielDataFromServer(false, "api/user/get-token", { ...newToken })
    .then((response) => {
      if (response?.error) {
        newToken?.onFail?.();
        return;
      }

     
      if (response?.qrCodeUrl) {
        setMfaPending({
          type:      "enroll",              
          secret:    response.secret,
          qrCodeUrl: response.qrCodeUrl,
          email:     newToken.email,
          password:  newToken.password,
        });
        newToken?.onMfaRequired?.("enroll");
        return;
      }

    
      if (response?.requireOTP === true || response?.requireOTP === "true") {
        setMfaPending({
          type:          "otp",             
          email:         newToken.email,
          password:      newToken.password,
          enableMailMfa: response.enableMailMfa === "true",
        });
        newToken?.onMfaRequired?.("otp");
        return;
      }

      
      setToken(response);
      localStorage.setItem("token", response);
      localStorage.setItem("provider_token", newToken?.token ?? "");
      localStorage.setItem("source", newToken?.source ?? "");
      newToken?.onSuccess?.();
    })
    .catch((error) => {
      newToken?.onFail?.();
      console.error("Error fetching user info:", error);
    });
};

const registerMfa = async ({ email, password, secret, otp, enableMailMfa, onSuccess, onFail }) => {
  try {
    const response = await fetch(`${config.baseURL}api/user/registerMfa`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, secret, otp, enableMailMfa }),
    });

    if (response.ok) {
      const jwt = (await response.text()).trim();   
      setToken(jwt);
      localStorage.setItem("token", jwt);
      localStorage.setItem("source", "basic");
      localStorage.setItem("provider_token", "");
      setMfaPending(null);          
      onSuccess?.();
    } else {
      const err = await response.json().catch(() => ({}));
      onFail?.(err?.message || "Code OTP invalide");
    }
  } catch {
    onFail?.("Erreur de connexion au serveur");
  }
};
  /*
  // ── Verify MFA ─────────────────────────────────────────────────────────────
  const verifyMfa = async ({ code, onSuccess, onFail }) => {
    if (!mfaPending) { onFail?.("Aucune session MFA en cours"); return; }

    try {
      const response = await fetch(`${config.baseURL}api/user/verify-mfa`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
          sessionToken: mfaPending.sessionToken,
          code,
        }),
      });

      if (response.ok) {
        const jwt = await response.text();
        setToken(jwt);
        localStorage.setItem("token", jwt);
        localStorage.setItem("source", "basic");
        setMfaPending(null);
        onSuccess?.();
        mfaPending.onSuccess?.();
      } else {
        const err = await response.json().catch(() => ({}));
        onFail?.(err?.message || "Code incorrect");
      }
    } catch {
      onFail?.("Erreur de connexion au serveur");
    }
  };
  */

  // ── Register ───────────────────────────────────────────────────────────────
  const register = async (registrationData) => {
    try {
      const response = await fetch(`${config.baseURL}api/user/register`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(registrationData),
      });

      if (response.ok) {
        const contentType = response.headers.get("content-type");
        let jwt = null;
        if (contentType && contentType.includes("application/json")) {
          const json = await response.json();
          jwt = json.token;
        } else {
          jwt = (await response.text()).trim();
        }
        if (jwt) {
          setToken(jwt);
          localStorage.setItem("token", jwt);
          localStorage.setItem("source", "basic");
          registrationData?.onSuccess?.();
        } else {
          registrationData?.onFail?.("Aucun token reçu");
        }
      } else {
        const errorData = await response.json();
        registrationData?.onFail?.(errorData.message || "Erreur lors de l'inscription");
      }
    } catch {
      registrationData?.onFail?.("Erreur de connexion au serveur");
    }
  };
  const resetMfa = async ({ onSuccess, onFail }) => {
  try {
    const response = await fetch(`${config.baseURL}api/user/resetMfa`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: localStorage.getItem("token") }),
    });
    if (response.ok) {
      onSuccess?.();
    } else {
      const err = await response.json().catch(() => ({}));
      onFail?.(err?.message || "Échec de la réinitialisation MFA");
    }
  } catch {
    onFail?.("Erreur de connexion au serveur");
  }
};

  // ── Logout ─────────────────────────────────────────────────────────────────
  const logout = () => {
    setToken(null);
    setMfaPending(null);
    //setShowMfaAdvice(false);
    localStorage.removeItem("token");
    localStorage.removeItem("source");
    localStorage.removeItem("provider_token");
    localStorage.removeItem("apiUserInfo");
  };



  // ── Restore token on mount ─────────────────────────────────────────────────
  useEffect(() => {
    const stored = localStorage.getItem("token");
    if (stored) setToken(stored);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token, setToken,
        login, register, logout,
        mfaPending, setMfaPending,
        openLoginDialog, setOpenLoginDialog,
        resetMfa,
        registerMfa,
        verifyOtp,        
        sendOtpMail,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default TSAuthProvider;
